module.exports = __webpack_public_path__ + "assets/img/login_tu3.42f768e3.png";